import { render } from "./App.vue?vue&type=template&id=95314aae"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=95314aae&lang=css"
import "./App.vue?vue&type=style&index=1&id=95314aae&lang=scss"
script.render = render

export default script